<template>
  <section class="gt-loading" v-show="show">
    <WtThemeIcon
      :class="['img', vertical ? 'vertical' : '']"
      :themeImg1="require('@/assets/img/loading1.gif')"
      :themeImg2="require('@/assets/img/loading2.gif')"
    />
  </section>
</template>
<script lange="ts">
import WtThemeIcon from "../WtThemeIcon.vue";
export default {
  components: {
    WtThemeIcon
  },
  props: {
    vertical: {
      type: [Boolean],
      default: true
    }
  },
  data() {
    return {
      show: true
    };
  }
};
</script>
<style lang="scss" scoped>
.gt-loading {
  display: flex;
  justify-content: center;
  position: absolute;
  align-items: flex-start;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: #f5f5f5;
  z-index: 99999;
  .img {
    width: 50px;
    height: 50px;

    &.vertical {
      margin-top: 50%;
    }
  }
}
</style>
